import { Check } from "lucide-react";
import { steps } from "../../data/quoteData";

export default function Progress({ current }) {
  return (
    <div className="progress-wrap container">
      <div className="progress">
        {steps.map((label, index) => {
          const number = index + 1;
          const done = number < current;
          const active = number === current;
          return (
            <div className={"progress-step " + (done ? "done " : "") + (active ? "active" : "")} key={label}>
              <div className="progress-line">
                <div className="step-circle">{done ? <Check size={17} /> : number}</div>
                {number < steps.length && <div className="line" />}
              </div>
              <div className="step-label">{label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
